import React from 'react';
import { TabsProps } from 'antd';
import AlertsList from '@/comp/MapBuilder/nodes/nodeWidget/DetailsDrawer/Tabs/AssetInfo/Alerts/AlertsList/AlertsList';
import { ALERT_TAB_CONFIGS, AlertTabConfig } from './AlertsSection.constants';
import type { AlertEntity } from '@/comp/AlertsBar/Alert';

export interface AlertGroups {
  activeAlerts: AlertEntity[];
  archivedAlerts: AlertEntity[];
  shutdownAlerts: AlertEntity[];
  warningAlerts: AlertEntity[];
  serviceAlerts: AlertEntity[];
}

const getAlertsForTab = (tabKey: string, alertGroups: AlertGroups): AlertEntity[] => {
  switch (tabKey) {
    case 'all':
      return alertGroups.activeAlerts;
    case 'shutdown':
      return alertGroups.shutdownAlerts;
    case 'warning':
      return alertGroups.warningAlerts;
    case 'service':
      return alertGroups.serviceAlerts;
    case 'archived':
      return alertGroups.archivedAlerts;
    default:
      return [];
  }
};

const createTabLabel = (
  config: AlertTabConfig,
  count: number,
  t: (key: string) => string,
): React.ReactNode => {
  const Icon = config.icon;
  const className = `alert-tab-label${config.className ? ` ${config.className}` : ''}`;
  const countText = config.showCount ? ` (${count})` : '';

  return (
    <div className={className}>
      {Icon && <Icon />}
      {t(config.translationKey)}
      {countText}
    </div>
  );
};

export const createTabItems = (
  alertGroups: AlertGroups,
  t: (key: string) => string,
): TabsProps['items'] => {
  return ALERT_TAB_CONFIGS.map(config => {
    const alerts = getAlertsForTab(config.key, alertGroups);
    const count = alerts.length;

    return {
      key: config.key,
      label: createTabLabel(config, count, t),
      children: <AlertsList alerts={alerts} archived={config.key === 'archived'} />,
    };
  });
};

